import script from "./Template2.vue?vue&type=script&setup=true&lang=js"
export * from "./Template2.vue?vue&type=script&setup=true&lang=js"

import "./Template2.vue?vue&type=style&index=0&id=ea05f274&scoped=true&lang=less"
import "./Template2.vue?vue&type=style&index=1&id=ea05f274&lang=css"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea05f274"]])

export default __exports__